const companySubscriptionConstants = {
	COMPANY_SUBSCRIPTION_POPULATE_SUCCESS:
		"COMPANY_SUBSCRIPTION_POPULATE_SUCCESS",
	COMPANY_SUBSCRIPTIONS_CREATE_SUCCESS: "COMPANY_SUBSCRIPTIONS_CREATE_SUCCESS",
	COMPANY_SUBSCRIPTION_FAILURE: "COMPANY_SUBSCRIPTION_FAILURE",
	COMPANY_SUBSCRIPTION_REQUEST_DONE: "COMPANY_SUBSCRIPTION_REQUEST_DONE",
	SET_COMPANY_SUBSCRIPTION_SUCCESS_MESSAGE:
		"SET_COMPANY_SUBSCRIPTION_SUCCESS_MESSAGE",
	COMPANY_SUBSCRIPTIONS_GET_REQUEST: "COMPANY_SUBSCRIPTIONS_GET_REQUEST",
};

export default companySubscriptionConstants;
